$(document).ready(function() {
    // Cache DOM elements for better performance
    const $navLinks = $('.col-nav nav a');
    const $sections = $('.col-card[id]');

    // Offset for sticky header consideration
    const offset = 0;

    function updateActiveNav() {
        let current = '';
        const scrollTop = $(window).scrollTop();

        // Find which section is currently in view
        $sections.each(function() {
            const $section = $(this);
            const sectionTop = $section.offset().top - offset;
            const sectionHeight = $section.outerHeight();

            // Check if section is in viewport
            if (scrollTop >= sectionTop && scrollTop < sectionTop + sectionHeight) {
                current = $section.attr('id');
                return false; // Break out of each loop
            }

            // If we're past all sections, highlight the last one
            if (scrollTop >= sectionTop) {
                current = $section.attr('id');
            }
        });

        // Update active state
        $navLinks.removeClass('active');
        if (current) {
            $navLinks.filter(`[href="#${current}"]`).addClass('active');
        } else {
            // If no section is active, keep the first one active
            $navLinks.first().addClass('active');
        }
    }

    // Smooth scrolling for navigation links
    $navLinks.on('click', function(e) {
        e.preventDefault();
        const targetId = $(this).attr('href');
        const $target = $(targetId);

        if ($target.length) {
            $('html, body').animate({
                scrollTop: $target.offset().top - offset + 1
            }, 500);
        }
    });

    // Update active nav on scroll
    $(window).on('scroll', function() {
        updateActiveNav();
    });

    // Update active nav on page load
    updateActiveNav();

    // Update active nav on window resize (in case layout changes)
    $(window).on('resize', function() {
        setTimeout(updateActiveNav, 100);
    });
});